import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Agendamento } from "../../../../services/Agendamento";
import { IIniciarAgendamentoProps } from "../../../../types/agendamento";

export const useAtribuirAgendamento = () => {
  return useMutation({
    mutationFn: (data: IIniciarAgendamentoProps) => Agendamento.atribuir(data),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
